module.exports = __webpack_public_path__ + "static/img/zhanlue-bg.0384b5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhanlue-bg.png
// module id = DZq1
// module chunks = 2